// Admin Configuration
// Diese Datei enthält nur noch die Session-Timeout-Konfiguration
// Admin-Berechtigungen werden ausschließlich über `session.user.app_metadata.role` bestimmt

// SICHERHEIT: Session-Timeout-Konfiguration (fest im Code)
export const SESSION_TIMEOUT_MINUTES = 30; // 30 Minuten fest eingestellt
